import { ItemExtract } from './itemextract.model';

export class ExtractResult {
  Ecritures: ItemExtract[];
  TotalPages: number;
  TotalEntries: number;
  CurrentPage: number;
}
